export default function Confirm({ 
    title = '',
    description = '',
    confirm = () => {}, 
    close
}) {
    
    return (
        <div className={`fixed z-50 top-0 left-0 overflow-hidden h-screen w-screen flex items-center justify-center`}>
            <div className="fixed inset-0 top-0 left-0 bg-black opacity-60 h-screen w-screen"></div>

            <div className="fixed top-40 w-[90vw] z-50">
                <div className="bg-an_white-dark rounded shadow-md w-full md:max-w-xl mx-auto z-50">
                    <h2 className="w-ful lowercase text-xl text-an_white text-center items-center p-4 bg-an_green-dark rounded-t">
                        {title}
                    </h2>

                    <div className="flex min-w-full p-8 justify-center">
                        <div className="w-full text-center an_green-dark lowercase">
                            {description}
                        </div>
                    </div>
                </div>

                <div className="flex justify-center w-full py-3 md:max-w-xl mx-auto">
                    <button
                        className="px-5 py-2 rounded w-36 text-an_green-dark bg-an_white mr-1"
                        onClick={close}
                    >
                        cancel
                    </button>

                    <button
                        className={`px-5 ml-1 py-2 relative rounded w-36 border border-an_orange-darker3 text-an_white bg-an_orange text-border-orange`}
                        onClick={confirm}
                    >
                        confirm
                    </button>
                </div>
            </div>

            
        </div>
    )
}